import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/dialpad-logo.vue
var c = {
	name: "DtIconDialpadLogo",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["fill"], d = ["id"];
function f(e, t, n, c, f, p) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([p.iconSizeClass, "d-icon d-icon--dialpad-logo"]),
		"data-qa": p.dataQA,
		"aria-hidden": p.ariaHidden,
		role: "img",
		"data-name": "Dialpad Logo",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		t[1] || (t[1] = i("path", {
			d: "M20.4.006H3.6a3.6 3.6 0 0 0-3.6 3.6v16.8a3.6 3.6 0 0 0 3.6 3.6h16.8a3.6 3.6 0 0 0 3.6-3.6v-16.8a3.6 3.6 0 0 0-3.6-3.6Z",
			fill: "#10022C"
		}, null, -1)),
		i("path", {
			d: "M20.4.006H3.6a3.6 3.6 0 0 0-3.6 3.6v16.8a3.6 3.6 0 0 0 3.6 3.6h16.8a3.6 3.6 0 0 0 3.6-3.6v-16.8a3.6 3.6 0 0 0-3.6-3.6Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, u),
		t[2] || (t[2] = i("path", {
			d: "M12.788 7.473c.127-.057.1-.276-.035-.306-2.02-.448-3.592-2.236-3.93-4.479-.021-.148-.284-.184-.338-.044-.87 2.68-2.752 4.777-5.256 5.8-.122.057-.097.26.034.292 1.972.474 3.503 2.23 3.846 4.429.023.145.263.178.318.042 1.003-2.804 2.922-4.91 5.361-5.734Z",
			fill: "#F8F7F6"
		}, null, -1)),
		t[3] || (t[3] = i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M15.135 20.706c-2.583 0-4.438-2.068-4.438-4.898 0-2.83 1.855-4.88 4.438-4.88 1.2 0 2.346.599 2.855 1.379V7.264h2.11v13.26h-2.11V19.31c-.509.78-1.655 1.397-2.855 1.397Zm.345-1.832c1.364 0 2.383-1.052 2.51-2.485V15.19c-.127-1.433-1.146-2.43-2.51-2.43-1.527 0-2.619 1.215-2.619 3.029 0 1.814 1.091 3.084 2.62 3.084Z",
			fill: "#F8F7F6"
		}, null, -1)),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "-3.75",
			y1: "-5.169",
			x2: "24.75",
			y2: "24.006",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [a("<stop offset=\".06\" stop-color=\"#10022C\"></stop><stop offset=\".2\" stop-color=\"#611F93\"></stop><stop offset=\".29\" stop-color=\"#8223A1\"></stop><stop offset=\".366\" stop-color=\"#9325A5\"></stop><stop offset=\".459\" stop-color=\"#C52599\" stop-opacity=\".9\"></stop><stop offset=\".564\" stop-color=\"#D52C86\"></stop><stop offset=\".658\" stop-color=\"#EA2F6F\"></stop><stop offset=\".737\" stop-color=\"#F64850\"></stop><stop offset=\".896\" stop-color=\"#FD6D2D\"></stop><stop offset=\".955\" stop-color=\"#FF9E0E\" stop-opacity=\".95\"></stop>", 10)])], 8, d)])
	], 10, l);
}
var p = /* @__PURE__ */ n(c, [["render", f]]);
//#endregion
export { p as default };

//# sourceMappingURL=dialpad-logo.js.map